w<template lang="pug">
.sidebar-inner
    .sidebar-inner__header(ref="infoBox")
        SidebarHeader(v-if="type !== 'nopol' && type !== 'email'" :route_name="route_name" :isKey="isKey")
    .sidebar-inner__body(v-if="route_name === 'PageResult' || route_name === 'PageTargetDetail'" v-bind:style="dynamicHeight")
        .sidebar-menu
            ul
                //- li(v-for="menusidebar in menusSidebar" :key="menusidebar.name")
                li(v-for="(menusidebar, index) in menusSidebar" :key="index")
                    //- router-link.flex.items-center.p-3(:to='menusidebar.url' :class="{ 'data-loaded' : menusidebar.dataLoaded }")
                    div.flex.items-center.p-3(v-if="menusidebar.subheaderLoaded && type !== 'msisdn' && load_data_status_profile_subheader.status ==='loading'" @click="handleDisabled")
                        i.icon.mr-2
                            .block
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path></svg>
                        span {{ menusidebar.name }}
                            template(v-if="menusidebar.dataCount")
                                
                                span.multiple-data-loading(v-if="menusidebar.dataLoaded == 'loading' && Object.values(menusidebar.dataCount).filter(key => finishedStatus.includes(key)).length != Object.keys(menusidebar.dataCount).length") [{{ Object.values(menusidebar.dataCount).filter(key => finishedStatus.includes(key)).length}}/{{ Object.keys(menusidebar.dataCount).length }}]
                                
                                span(v-else-if="menusidebar.dataLoaded == 'loading' && Object.values(menusidebar.dataCount).filter(key => finishedStatus.includes(key)).length == Object.keys(menusidebar.dataCount).length" :data-action="changeStatus(menusidebar.loadState, menusidebar.countState)")

                    router-link.flex.items-center.p-3(
                        v-else
                        :to="{ path: menusidebar.url }" :class="{ 'data-loaded' : menusidebar.dataLoaded }"
                        @click.native="toggleSidebar()"
                        )
                        i.icon.mr-2
                            //- .block.loading(v-if="menusidebar.dataLoaded === 'loading' || menusidebar.dataLoaded.status === 'loading'")
                            .block.loading(v-if="menusidebar.dataLoaded === 'loading'")
                                Spinner(show="true" size="28")

                            //- .block.warning(v-else-if="menusidebar.dataLoaded === 'empty'")
                            //- .block.failed(v-else-if="menusidebar.dataLoaded === 'empty' || menusidebar.dataLoaded.status === 'empty'")
                            .block.failed(v-else-if="menusidebar.dataLoaded === 'empty'")
                                //- <svg v-tooltip="'Data is empty.'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                                <svg v-tooltip="'Failed'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                
                            //- .block.warning(v-else-if="menusidebar.dataLoaded === 'partially-empty'")
                            //- .block.success(v-else-if="menusidebar.dataLoaded === 'partially-empty' || menusidebar.dataLoaded.status === 'partially-empty'")
                            .block.success(v-else-if="menusidebar.dataLoaded === 'partially-empty'")
                                //- <svg v-tooltip="'Data is partially empty.'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                                <svg v-tooltip="'Success'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>

                            //- .block.failed(v-else-if="menusidebar.dataLoaded === 'failed' || menusidebar.dataLoaded.status === 'failed'")
                            .block.failed(v-else-if="menusidebar.dataLoaded === 'failed'")
                                <svg v-tooltip="'Failed'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>

                            .block.success(v-else-if="menusidebar.dataLoaded === true")
                                <svg v-tooltip="'Success'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>

                            .block(v-else)
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path></svg>

                        span {{ menusidebar.name }}
                            template(v-if="menusidebar.dataCount")

                                span.multiple-data-loading(v-if="menusidebar.dataLoaded == 'loading' && Object.values(menusidebar.dataCount).filter(key => finishedStatus.includes(key)).length !== Object.keys(menusidebar.dataCount).length") [{{ Object.values(menusidebar.dataCount).filter(key => finishedStatus.includes(key)).length}}/{{ Object.keys(menusidebar.dataCount).length }}]

                                span(v-else-if="menusidebar.dataLoaded == 'loading' && Object.values(menusidebar.dataCount).filter(key => finishedStatus.includes(key)).length == Object.keys(menusidebar.dataCount).length" :data-action="changeStatus(menusidebar.loadState, menusidebar.countState)")

</template>

<script>
import { mapState } from 'vuex';
import SidebarHeader from './SidebarHeader.vue';
import Spinner from '@/components/Spinner.vue';
import { decrypt } from '@/util/crypto';

export default {
    name: 'Sidebar',
    components: {
        SidebarHeader,
        Spinner,
    },
    data: function() {
        return {
            dynamicHeight: {
                overflow: 'auto',
                maxHeight: 'auto',
            },
            finishedStatus: [true, 'empty', 'partially-empty', 'failed'],
            isAstro: process.env.VUE_APP_ASTRO,
            type: null,
        }
    },
    props: ['isKey'],
    computed: {
        ...mapState([
            'auth_data',
            'load_data_status_profile_subheader',
            'load_data_status_single_target_detail', // detail target only
            'load_data_status_overall_app_usage',
            'load_data_status_overall_data_location',
            'load_data_status_location',
            'load_data_status_location_count',
            'load_data_status_browsing',
            // 'load_data_status_browsing_count',
            'load_data_status_device_history',
            'load_data_status_tethered_device',
            'load_data_status_possible_location',
            'load_data_status_aerial_log',
            'load_data_status_signal_status',
            'load_data_status_profile',
            'load_data_status_profile_count',
            'load_data_status_get_contact',
            'load_data_status_tokped',
            'load_data_status_travel_history',
            'load_data_status_search_by_name_travel_history',
            'load_data_status_vehicles',
            'load_data_status_etle',
            'load_data_status_bank_account',
            'load_data_status_personal_identity',
            'load_data_status_travel',
            'load_data_status_pln',
        ]),
        route_name() {
            return this.$route.matched[0] ? this.$route.matched[0].name : null;
        },
        key() {
            return this.$route.params.key;
        },
        menusSidebar() {
            let menusSidebar = [];
            if (this.isAstro === 'true') {
                menusSidebar = [
                    {
                        name: 'Recent Location',
                        url: 'recent-location',
                        dataLoaded: this.load_data_status_overall_data_location.status,
                    },
                ];
            } else {

                if (this.isKey) {

                    // let menu_data = [];

                    let decrypt_data = decrypt(this.key);
                    decrypt_data = decrypt_data.split('&&');

                    // var key = decrypt_data[0];
                    var type = decrypt_data[1];
                    this.type = type; // eslint-disable-line vue/no-side-effects-in-computed-properties

                    // console.log(type);
                    if (type === 'msisdn' || type === 'imsi' || type === 'imei-sv') {
                        menusSidebar = [];
                        if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','recent_location')){
                            menusSidebar.push(
                                {
                                    name: 'Recent Location',
                                    url: 'recent-location',
                                    dataLoaded: this.load_data_status_overall_data_location.status,
                                }
                            )
                        }
                        if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','application_usage')){
                            menusSidebar.push(
                                {
                                    name: 'Application Usage',
                                    url: 'application-usage',
                                    dataLoaded: this.load_data_status_overall_app_usage.status,
                                }
                            )
                        }
                        if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','history_location')){
                            menusSidebar.push(
                                {
                                    name: 'History Location',
                                    url: 'history-location',
                                    dataLoaded: this.load_data_status_location.status,
                                    dataCount: this.load_data_status_location_count,
                                    loadState: 'setLoadDataStatusLocation',
                                    countState: 'load_data_status_location_count'
                                }
                            )
                        }

                        if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','history_browsing')){
                            menusSidebar.push(
                                {
                                    name: 'History Browsing',
                                    url: 'history-browsing',
                                    dataLoaded: this.load_data_status_browsing.status,
                                }
                            )
                        }
                            

                        if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','device_history')){
                            menusSidebar.push(
                                {
                                    name: 'Device History',
                                    url: 'device-history',
                                    dataLoaded: this.load_data_status_device_history.status,
                                }
                            )
                        }
                            

                        if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','tethered_devices')){
                            menusSidebar.push(
                                {
                                    name: 'Tethered Devices',
                                    url: 'tethered-devices',
                                    dataLoaded: this.load_data_status_tethered_device.status,
                                }
                            )
                        }


                        if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','possible_location')){
                            menusSidebar.push(
                                {
                                    name: 'Possible Location',
                                    url: 'possible-location',
                                    dataLoaded: this.load_data_status_possible_location.status,
                                }
                            )
                        }


                        if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','aerial_log')){
                            menusSidebar.push(    
                                {
                                    name: 'Aerial Log',
                                    url: 'aerial-log',
                                    dataLoaded: this.load_data_status_aerial_log.status,
                                }
                            )
                        }


                        if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','signal_status')){
                            menusSidebar.push(    
                                {
                                    name: 'Signal Status',
                                    url: 'signal-status',
                                    dataLoaded: this.load_data_status_signal_status.status,
                                }
                            )
                        }


                        if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','profile')){
                            menusSidebar.push(    
                                {
                                    name: 'Profile',
                                    url: 'profile',
                                    dataLoaded: this.load_data_status_profile.status,
                                    dataCount: this.load_data_status_profile_count,
                                    loadState: 'setLoadDataStatusProfile',
                                    countState: 'load_data_status_profile_count',
                                }
                            )
                        }


                        if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','prediction_nickname')){
                            menusSidebar.push(    
                                {
                                    name: 'Prediction Nickname',
                                    url: 'prediction-nickname',
                                    dataLoaded: this.load_data_status_get_contact.status,
                                    subheaderLoaded: true,
                                }
                            )
                        }

                        if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','marketplace')){
                            menusSidebar.push(    
                                {
                                    name: 'Marketplace',
                                    url: 'marketplace',
                                    dataLoaded: this.load_data_status_tokped.status,
                                    subheaderLoaded: true,
                                }
                            )
                        }


                        // if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','travel_history') || this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','imigration')){
                        //     menusSidebar.push(    
                        //         {
                        //             name: 'Imigration',
                        //             url: 'travel-history',
                        //             dataLoaded: this.load_data_status_search_by_name_travel_history,
                        //             subheaderLoaded: true,
                        //         }
                        //     )
                        // }

                        // if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','travel_pl')){
                        //     menusSidebar.push(    
                        //         {
                        //             name: 'Travel',
                        //             url: 'travel',
                        //             dataLoaded: this.load_data_status_travel.status,
                        //         }
                        //     )
                        // }

                        // if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','bank_account')){
                        //     menusSidebar.push(    
                        //         {
                        //             name: 'Bank Account',
                        //             url: 'bank-account',
                        //             dataLoaded: this.load_data_status_bank_account.status,
                        //             subheaderLoaded: true,
                        //         }
                        //     )
                        // }


                        if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','application_usage')){
                            menusSidebar.push(    
                            )
                        }
                        // ];

                        if (type === 'msisdn') {

                            if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','personal_identity')){
                                menusSidebar.push({
                                    name: 'Personal Identity',
                                    url: 'personal-identity',
                                    dataLoaded: this.load_data_status_personal_identity.status,
                                    subheaderLoaded: true,
                                });
                            }
                        }

                    } else if (type === 'nik') {
                        menusSidebar = [];

                        if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','profile')){
                            menusSidebar.push(    
                                {
                                    name: 'Profile',
                                    url: 'profile',
                                    dataLoaded: this.load_data_status_profile.status,
                                    dataCount: this.load_data_status_profile_count,
                                    loadState: 'setLoadDataStatusProfile',
                                    countState: 'load_data_status_profile_count',
                                }
                            )
                        }
                        
                        // if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','travel_history') || this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','imigration')){
                        //     menusSidebar.push(    
                        //         {
                        //             name: 'Imigration',
                        //             url: 'travel-history',
                        //             dataLoaded: this.load_data_status_search_by_name_travel_history,
                        //         }
                        //     )
                        // }

                        // if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','travel_pl')){
                        //     menusSidebar.push(    
                        //         {
                        //             name: 'Travel',
                        //             url: 'travel',
                        //             dataLoaded: this.load_data_status_travel.status,
                        //         }
                        //     )
                        // }
                        // ];

                    } else if (type === 'nopol') {

                        menusSidebar = [];

                        if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','vehicles')){
                            menusSidebar.push(    
                                {
                                    name: 'Vehicles',
                                    url: 'vehicles',
                                    dataLoaded: this.load_data_status_vehicles.status,
                                }
                            )
                        }
                        
                        // if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','etilang')){
                        //     menusSidebar.push(    
                        //         {
                        //             name: 'eTilang',
                        //             url: 'etilang',
                        //             dataLoaded: this.load_data_status_etle.status,
                        //         }
                        //     )
                        // }
                        // ];

                    } else if (type === 'email') {
                        menusSidebar = [];
                            // {
                            //     name: 'Tokopedia',
                            //     url: 'tokopedia',
                            //     dataLoaded: false,
                            // },
                            
                        if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','personal_identity')){
                            menusSidebar.push(    
                                {
                                    name: 'Personal Identity',
                                    url: 'personal-identity',
                                    dataLoaded: this.load_data_status_personal_identity.status,
                                }
                            )
                        }
                        
                        if(this.checkFeatureByAcl(this.auth_data,'sidebar_tracking','marketplace')){
                            menusSidebar.push(    
                                {
                                    name: 'Marketplace',
                                    url: 'marketplace',
                                    dataLoaded: this.load_data_status_tokped.status,
                                }
                            )
                        }
                        // ];
                    }
                }

                // ------------------------------------------------------------

                // menusSidebar = [
                //     {
                //         name: 'Recent Location',
                //         url: 'recent-location',
                //         dataLoaded: this.load_data_status_overall_data_location,
                //     },
                //     {
                //         name: 'Application Usage',
                //         url: 'application-usage',
                //         dataLoaded: this.load_data_status_overall_app_usage,
                //     },
                //     {
                //         name: 'History Location',
                //         url: 'history-location',
                //         dataLoaded: this.load_data_status_location,
                //         dataCount: this.load_data_status_location_count,
                //         loadState: 'setLoadDataStatusLocation',
                //         countState: 'load_data_status_location_count'
                //     },
                //     {
                //         name: 'History Browsing',
                //         url: 'history-browsing',
                //         dataLoaded: this.load_data_status_browsing,
                //         dataCount: this.load_data_status_browsing_count,
                //         loadState: 'setLoadDataStatusBrowsing',
                //         countState: 'load_data_status_browsing_count',
                //     },
                //     {
                //         name: 'Device History',
                //         url: 'device-history',
                //         // dataLoaded: 'loading',
                //         dataLoaded: this.load_data_status_device_history,
                //     },
                //     {
                //         name: 'Tethered Devices',
                //         url: 'tethered-devices',
                //         dataLoaded: this.load_data_status_tethered_device,
                //     },
                //     {
                //         name: 'Possible Location',
                //         url: 'possible-location',
                //         dataLoaded: this.load_data_status_possible_location,
                //     },
                //     {
                //         name: 'Aerial Log',
                //         url: 'aerial-log',
                //         dataLoaded: this.load_data_status_aerial_log,
                //     },
                //     {
                //         name: 'Signal Status',
                //         url: 'signal-status',
                //         dataLoaded: this.load_data_status_signal_status,
                //     },
                //     {
                //         name: 'Profile',
                //         url: 'profile',
                //         dataLoaded: this.load_data_status_profile,
                //         dataCount: this.load_data_status_profile_count,
                //         loadState: 'setLoadDataStatusProfile',
                //         countState: 'load_data_status_profile_count',
                //     },
                //     {
                //         name: 'Prediction Nickname',
                //         url: 'prediction-nickname',
                //         dataLoaded: this.load_data_status_get_contact.status,
                //     },
                //     {
                //         name: 'Vehicles',
                //         url: 'vehicles',
                //         dataLoaded: this.load_data_status_vehicles,
                //     },
                //     {
                //         name: 'Marketplace',
                //         url: 'marketplace',
                //         dataLoaded: false,
                //     },
                //     {
                //         name: 'Health Alert',
                //         url: 'health-alert',
                //         dataLoaded: false,
                //     },
                //     {
                //         name: 'Ticket',
                //         url: 'Ticket',
                //         dataLoaded: false,
                //     },
                //     // {
                //     //     name: '-------------------------',
                //     //     url: 'result',
                //     //     dataLoaded: false,
                //     // },
                //     // {
                //     //     name: 'Overall',
                //     //     url: 'overall',
                //     //     dataLoaded: 'loading',
                //     // },
                //     // {
                //     //     name: 'History App',
                //     //     url: 'history-app',
                //     //     dataLoaded: 'empty',
                //     // },
                // ];
            }

            // for target sidebar
            if (this.route_name === 'PageTargetDetail') {
                menusSidebar.unshift({
                    name: 'Target Information',
                    url: 'home',
                    dataLoaded: this.load_data_status_single_target_detail,
                });
            }

            return menusSidebar;
        },
    },
    watch: {
        route_name() {},
        key() {
            this.matchHeight();
        },
        menusSidebar() {},
    },
    methods: {
        matchHeight () {
            let height = this.$refs.infoBox.clientHeight;
            let heightScreen = window.innerHeight;
            let heightSidebarMenu = (heightScreen - (height + 48)) + 'px';
            this.dynamicHeight.maxHeight = heightSidebarMenu;
        },
        changeStatus(loadState, countState) {
            // console.log('================== in Sidebar methods changeStatus()');

            var count_data = this[countState];

            var count_data_length = Object.keys(count_data).length;
            var count_data_success = Object.values(count_data).filter(key => [true].includes(key)).length;
            var count_data_empty = Object.values(count_data).filter(key => ['empty'].includes(key)).length;
            var count_data_partially_empty = Object.values(count_data).filter(key => ['partially-empty'].includes(key)).length;
            var count_data_failed = Object.values(count_data).filter(key => ['failed'].includes(key)).length;

            let status;

            if (count_data_success === count_data_length) {
                status = true;
            } else if (count_data_empty === count_data_length) {
                status = 'empty';
            } else if (count_data_partially_empty === count_data_length) {
                status = 'partially-empty';
            } else if (count_data_failed === count_data_length) {
                status = 'failed';
            } else {
                status = 'partially-empty';
            }

            // console.log('in changeStatus')
            // console.log(loadState)
            // console.log(countState)
            // console.log(status)
            // console.log(count_data)

            // this.$store.commit(loadState, status);
            this.$store.commit(loadState, {
                status: status,
                code: this[countState.replace('_count', '')].code,
                cancel: this[countState.replace('_count', '')].cancel,
            });

            // console.log()
            // console.log('--------------------------------------')
            // console.log(this.$store.state[countState.replace('_count', '')])
        },

        toggleSidebar() {
            EventEmit.$emit('toggleSidebar')
        },
        handleDisabled() {
            this.$swal.fire({
                icon: 'warning',
                title: process.env.VUE_APP_WORDING_SUBHEADER_LOADED || "Data not ready, please wait!",
                timer: 3000,
            });
        },
        // checkFeatureByAcl(user, module, func) {
        //     if (user && user.role && user.role.label === 'superadmin') {
        //         return true
        //     } else {
        //         let funcArr = []
        //         try {
        //             let moduleACL = user.role.module.filter(function(item) {
        //                 return item.label.toUpperCase() === module.toUpperCase();
        //             });
        //             if (func == null) {
        //                 funcArr = moduleACL
        //             } else {  
        //                 funcArr = moduleACL[0].function.filter(function(item) {
        //                     return item.label.toUpperCase() === func.toUpperCase();
        //                 });
        //             }
        //         } catch (error) {
        //             console.log('error checkFeatureByAcl')
        //             console.log(error)
        //         }
        //         return funcArr.length? true : false
        //     }
        // }
    },
    mounted () {
        this.matchHeight();

        // console.log('================== in Sidebar.vue');
        // // console.log(this.$route.params.key);
        // console.log(this.key);
    }
}
</script>

<style lang="sass">
</style>
